export const setCampsite = (campsite) => ({
  type: "SET_CAMPSITE",
  campsite,
});
